module.exports = __webpack_public_path__ + "img/pog_guardian_greaves.296b3cba.png";